import { LogIn } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import landingHero from '@/customer/assets/landing-hero.webp'
import landingHeroMobile from '@/customer/assets/landing-hero-mobile.webp'
import { StackedHeadline } from '@/customer/components/stacked-headline'
import { Button } from '@/customer/components/ui/button'
import { useDocumentTitle } from '@/customer/hooks/use-document-title'
import { routes } from '@/customer/routes'

/**
 * Customer-portal fallback entry. Most users are linked directly into the
 * sign-in or registration flow from marketing, so this page optimises for the
 * returning-user case with a single primary CTA and a subtle nudge for new
 * users.
 *
 * Renders its own full-bleed layout (rather than the shared `RegistrationLayout`)
 * so the hero image can sit alongside the content on desktop and as a top
 * banner on mobile.
 */
export function LandingPage() {
  useDocumentTitle(null)

  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-background text-foreground xl:grid xl:grid-cols-2">
      <div className="xl:h-screen">
        <picture>
          <source media="(min-width: 1280px)" srcSet={landingHero} />
          <img
            src={landingHeroMobile}
            alt=""
            className="aspect-[4/3] max-h-[50vh] w-full object-cover object-center xl:aspect-auto xl:max-h-screen xl:h-full xl:object-[center_35%]"
          />
        </picture>
      </div>

      <div className="flex flex-col px-6 py-8 xl:min-h-screen xl:px-12">
        <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center gap-10 py-8 xl:py-12">
          <StackedHeadline
            lines={[
              { text: 'Welcome', color: 'pink' },
              { text: 'to Snoots', color: 'yellow' },
            ]}
          />

          <div className="flex flex-col gap-6">
            <Button size="lg" className="h-14 w-full" onClick={() => navigate(routes.signIn)}>
              <LogIn />
              Sign in
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
